import { getUnifiedCodeLanguageId } from '../getUnifiedCodeLanguageId';

// returns the unique params for the first paramter of the function
export const getUniqueParams = (
  a: Record<string, string>,
  b: Record<string, string>,
): Record<string, string> => {
  // no need to add a default param to the query string
  return Object.entries(a).reduce(
    (arr: Record<string, string>, [activeKey, activeValue]) => {
      if (
        getUnifiedCodeLanguageId(b[activeKey]) !==
        getUnifiedCodeLanguageId(activeValue)
      ) {
        return { ...arr, [activeKey]: activeValue };
      }
      return arr;
    },
    {},
  );
};
